import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaFacebookF, FaWhatsapp } from "react-icons/fa";
import { FiArrowUp } from "react-icons/fi";
import venueData from "../../data/venueData";
import { navLinks } from "./navLinks";
import eventTypes from "../../data/eventTypes";
import "./footer.css";

/**
 * Footer — large editorial footer on plum background with a low-opacity
 * wordmark, navigation, event links, and contact details.
 */
export default function Footer() {
  return (
    <footer className="site-footer bg-plum">
      <div className="container-wide footer-top">
        <div className="footer-brand">
          <span className="footer-logo">Beejees</span>
          <p className="body-text footer-statement">
            A convention and celebration venue in Pirayiri, Palakkad — built for weddings, conferences and every gathering in between.
          </p>
          <Link to="/plan-your-event" className="btn-beejees-primary">
            Plan Your Event
          </Link>
        </div>

        <div className="footer-col">
          <h3 className="footer-col-title">Navigate</h3>
          <ul>
            {navLinks.map((l) => (
              <li key={l.to}><Link to={l.to}>{l.label}</Link></li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h3 className="footer-col-title">Events</h3>
          <ul>
            {eventTypes.slice(0, 5).map((e) => (
              <li key={e.slug}><Link to={`/events#${e.slug}`}>{e.name}</Link></li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h3 className="footer-col-title">Contact</h3>
          <ul className="footer-contact">
            <li><a href={`tel:${venueData.contact.phonePrimary}`}>{venueData.contact.phonePrimary}</a></li>
            <li><a href={`mailto:${venueData.contact.email}`}>{venueData.contact.email}</a></li>
            <li>{venueData.address.full}</li>
            <li>{venueData.contact.hours}</li>
          </ul>
          <div className="footer-social">
            <a href={venueData.social.instagram} aria-label="Beejees on Instagram"><FaInstagram /></a>
            <a href={venueData.social.facebook} aria-label="Beejees on Facebook"><FaFacebookF /></a>
            <a href={`https://wa.me/${venueData.contact.whatsapp.replace(/\D/g, "")}`} aria-label="Beejees on WhatsApp"><FaWhatsapp /></a>
          </div>
        </div>
      </div>

      <div className="footer-wordmark" aria-hidden="true">BEEJEES</div>

      <div className="container-wide footer-bottom">
        <p>&copy; {new Date().getFullYear()} Beejees Convention Centre. All rights reserved.</p>
        <div className="footer-bottom-links">
          <Link to="/contact">Privacy Policy</Link>
          <Link to="/contact">Terms</Link>
        </div>
        <button
          className="footer-back-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="Back to top"
        >
          <FiArrowUp />
        </button>
      </div>
    </footer>
  );
}
